function toParamString(params) {
  const paramsStringArray = [];

  Object.keys(params).forEach(key => {
    paramsStringArray.push(`${key}=${params[key]}`);
  });

  return paramsStringArray.join('&');
}

const defaultParams = {
  from: 'nav_header',
};

export const defaultParamsString = toParamString(defaultParams);
